"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiplePropertyListingsUserFields$ = exports.MultiplePropertyListingsUserFields$outboundSchema = exports.MultiplePropertyListingsUserFields$inboundSchema = exports.MultiplePropertyListingsUserFields = void 0;
const z = __importStar(require("zod"));
exports.MultiplePropertyListingsUserFields = {
    Agent: "agent",
    ListingId: "listing_id",
    ListingType: "listing_type",
    ListedDate: "listed_date",
    DaysOnMarket: "days_on_market",
    RenewalDate: "renewal_date",
    DaysToRenewal: "days_to_renewal",
    DaysSinceListing: "days_since_listing",
    StreetGroupPropertyId: "street_group_property_id",
    Location: "location",
    PropertyType: "property_type",
    DisplayAddress: "display_address",
    Address: "address",
    Status: "status",
    IsAvailable: "is_available",
    IsLatestListing: "is_latest_listing",
    IsRemoved: "is_removed",
    Price: "price",
    WeeklyPrice: "weekly_price",
    OriginalPrice: "original_price",
    NumberOfBedrooms: "number_of_bedrooms",
    NumberOfBathrooms: "number_of_bathrooms",
    MainImageUrl: "main_image_url",
    Images: "images",
    InternalAreaSquareMetres: "internal_area_square_metres",
    Description: "description",
    Source: "source",
    HasReduction: "has_reduction",
    ListingEvents: "listing_events",
    DistanceFromPoint: "distance_from_point",
    ListingQuality: "listing_quality",
    Tenure: "tenure",
    CouncilTaxBand: "council_tax_band",
    EnergyEfficiencyRating: "energy_efficiency_rating",
    IsBungalow: "is_bungalow",
    OutdoorSpaceAreaSquareMetres: "outdoor_space_area_square_metres",
    GardenDirection: "garden_direction",
    YearsAtProperty: "years_at_property",
    EstimatedValue: "estimated_value",
    EstimatedValueRounded: "estimated_value_rounded",
    Ownership: "ownership",
    YearBuilt: "year_built",
    HasHmo: "has_hmo",
    PropensityToLetScore: "propensity_to_let_score",
};
/** @internal */
exports.MultiplePropertyListingsUserFields$inboundSchema = z.nativeEnum(exports.MultiplePropertyListingsUserFields);
/** @internal */
exports.MultiplePropertyListingsUserFields$outboundSchema = exports.MultiplePropertyListingsUserFields$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiplePropertyListingsUserFields$;
(function (MultiplePropertyListingsUserFields$) {
    /** @deprecated use `MultiplePropertyListingsUserFields$inboundSchema` instead. */
    MultiplePropertyListingsUserFields$.inboundSchema = exports.MultiplePropertyListingsUserFields$inboundSchema;
    /** @deprecated use `MultiplePropertyListingsUserFields$outboundSchema` instead. */
    MultiplePropertyListingsUserFields$.outboundSchema = exports.MultiplePropertyListingsUserFields$outboundSchema;
})(MultiplePropertyListingsUserFields$ || (exports.MultiplePropertyListingsUserFields$ = MultiplePropertyListingsUserFields$ = {}));
//# sourceMappingURL=multiplepropertylistingsuserfields.js.map